import 'css/src/components/share-video/SpinoffCard';

import React from 'react';

import {
    ContentPlaceholderBlock,
    ContentPlaceholderSingleLineText,
} from 'js/src/components/common/ui/ContentPlaceholder';

export const SpinoffCardPlaceholder = () => {
    return (
        <div className="position-relative spinoff-card w-100">
            <div className="w-100 p-l5-8 d-flex gap-2">
                <div className="spinoff-card__preview position-relative">
                    <ContentPlaceholderBlock />
                </div>
                <div className="w-100 d-flex flex-column justify-content-between">
                    <div>
                        <ContentPlaceholderSingleLineText styleProps={{ width: '60%' }} />
                    </div>
                    <div>
                        <ContentPlaceholderSingleLineText styleProps={{ width: '30%' }} />
                    </div>
                </div>
            </div>
        </div>
    );
};
